import { patch } from '../fetch-instance'
import { logErrorToServer } from '../utils/eventLogger'
import { SET_AUTH } from './auth'

export const PATCH_REQUEST_USER_UPDATE = 'PATCH_REQUEST_USER_UPDATE'
export const SET_REQUEST_USER_UPDATE = 'SET_REQUEST_USER_UPDATE'
export const SET_REQUEST_USER_UPDATE_ERROR = 'SET_REQUEST_USER_UPDATE_ERROR'
export const CLEAR_REQUEST_USER_UPDATE = 'CLEAR_REQUEST_USER_UPDATE'

export const updateUserRequest =
  ({ firstName, lastName, stt, regions, hasFRAAccess }) =>
  async (dispatch, getState) => {
    dispatch({ type: PATCH_REQUEST_USER_UPDATE })
    const URL = `${process.env.REACT_APP_BACKEND_URL}/users/update_profile/`
    const user = {
      first_name: firstName,
      last_name: lastName,
      stt: stt?.id,
      has_fra_access: hasFRAAccess,
      create_change_requests: true,
      // backend requires region value if region key is present.
      // this guards it so the key isn't present if value isn't
      ...(Array.isArray(regions) && regions.length > 0 ? { regions } : {}),
    }
    const { data, ok, error } = await patch(URL, user)

    if (!ok) {
      logErrorToServer(SET_REQUEST_USER_UPDATE_ERROR)
      dispatch({ type: SET_REQUEST_USER_UPDATE_ERROR, payload: { error } })
      return
    }

    if (data) {
      const currentUser = getState()?.auth?.user || {}
      const userForAuth =
        (data?.pending_requests ?? 0) > 0
          ? {
              ...data,
              first_name: currentUser.first_name,
              last_name: currentUser.last_name,
              stt: currentUser.stt,
              regions: currentUser.regions,
            }
          : data

      dispatch({ type: SET_REQUEST_USER_UPDATE })
      dispatch({
        type: SET_AUTH,
        payload: { user: userForAuth },
      })
    } else {
      dispatch({ type: CLEAR_REQUEST_USER_UPDATE })
    }
  }
